// src/components/ProjectCard.js (NEW FILE)

import React from "react";
import { useNavigate } from "react-router-dom";
import "./About.css"; // We can reuse the same CSS

const ProjectCard = ({ project }) => {
  const navigate = useNavigate();

  // The mainImage path for projects might be different, adjust if needed
  // This assumes it's coming from an API like the products
  const prefixedMainImage =
    project.mainImage && project.mainImage.startsWith("http")
      ? project.mainImage
      : `https://apiqms.shigjeta.com${project.mainImage}`;

  const handleCardClick = () => {
    if (project.id) {
      // We will navigate to a new route for projects
      navigate(`/projects/${project.id}`);
    } else {
      console.error("Project Card Error: Project is missing an 'id'.", project);
    }
  };

  return (
    // We can reuse the same CSS class for a consistent look
    <div className="shop-product-card" onClick={handleCardClick}>
      <img src={prefixedMainImage} alt={project.name} />
      <h3 className="product-title">{project.name}</h3>
    </div>
  );
};

export default ProjectCard;
